import { zoneStore, syncQueue } from '../../offline/indexedDBService'
import { v4 as uuidv4 } from 'uuid'
import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getZones = (page = null, limit = null, search = '') => async (dispatch) => {
    dispatch({ type: 'ZONE_LOADING' })
    try {
        const { data, status } = await Axios.post('/api/zone/getall/', { page, limit, search }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ZONE_GETALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'ZONE_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'ZONE_NOT_LOADING' })
    }
}

export const getForSelect = () => async (dispatch) => {
    dispatch({ type: 'ZONE_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/zone/getforselect/', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ZONE_GETALLFORSELECT_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'ZONE_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'ZONE_NOT_LOADING' })
    }
}

export const getZone = (zone) => async (dispatch) => {
    dispatch({ type: 'ZONE_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/zone/get/' + zone, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ZONE_GET_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'ZONE_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'ZONE_NOT_LOADING' })
    }
}

export const addZone = (zonedata) => async (dispatch, getState) => {
	const tempId = uuidv4()
	const { farmsForSelect } = getState().farms

	if (!navigator.onLine) {
		await zoneStore.setItem(tempId, zonedata)
		await syncQueue.setItem(tempId, {
			type: 'ZONE_ADD_OFFLINE',
			payload: zonedata
		})
		dispatch({
			type: 'ZONE_ADD_SUCCESS',
			payload: {
				zone: { ...zonedata, _id: tempId, id: tempId, offline: true,
					farm: farmsForSelect.find(farm => farm._id === zonedata.farm) || {
						_id: zonedata.farm,
						name: zonedata.farm
					} },
				message: 'success'
			}
		})
		return
	}

	try {
		const { data, status } = await Axios.post('/api/zone/register', zonedata, {
			headers: { auth: localStorage.getItem('jwt') }
		})
		if (status === 200) {
			dispatch({ type: 'ZONE_ADD_SUCCESS', payload: data })
		} else if (status === 264 || status === 260) {
			dispatch({ type: 'ZONE_WRONG_SUCCESS', payload: data })
		} else {
			dispatch({ type: 'ZONE_NOT_LOADING' })
		}
	} catch (error) {
		dispatch({ type: 'ZONE_NOT_LOADING' })
	}
}

export const editZone = (zonedata, zoneId) => async (dispatch, getState) => {
	const { farmsForSelect } = getState().farms

	if (!navigator.onLine) {
		await zoneStore.setItem(zoneId, zonedata)
		await syncQueue.setItem(zoneId, {
			type: 'ZONE_EDIT_OFFLINE',
			payload: zonedata
		})
		dispatch({
			type: 'ZONE_EDIT_SUCCESS',
			payload: {
				zone: { ...zonedata, _id: zoneId, offline: true,
					farm: farmsForSelect.find(farm => farm._id === zonedata.farm) || {
						_id: zonedata.farm,
						name: zonedata.farm
					} },
				message: 'editSuccess'
			}
		})
		return
	}

	try {
		const { data, status } = await Axios.put('/api/zone/edit/' + zoneId, zonedata, {
			headers: { auth: localStorage.getItem('jwt') }
		})
		if (status === 200 || status === 264) {
			dispatch({ type: 'ZONE_EDIT_SUCCESS', payload: data })
		}
	} catch (error) {
		dispatch({ type: 'ZONE_NOT_LOADING' })
	}
}